/**
 * @module Main
 * @description Our Main JS file
 */
import debounce from 'lodash-es/debounce';
import applyBrowserClasses from '@/js/utils/dom/apply-browser-classes';
import resize from '@/js/core/resize';
import { setCookie } from './utils/cookie';
import { persistData } from './utils/session-storage';

/**
 * @function bindEvents
 * @description Bind global event listeners here,
 */
const bindEvents = () => window.addEventListener( 'resize', debounce( resize, 200, false ) );

/**
  * @function init
  * @description Kick off this modules functions
  */
const init = () => {
  // Set session cookie with inital query string for use in cart's Preamp audiences. Expires in 30 minutes
  setCookie( 'queryString', window.location.search, 30 );
  persistData( 'queryString', window.location.search );

  // Apply browser classes
  applyBrowserClasses();

  // Set initial states
  resize();

  // Initialize global events
  bindEvents();

  document.body.classList.add( 'browser-ready' );
};

export default init;
